<template>
  <div class="sp-page">
    <div class="page-header">
      <img class="header-img" src="@/assets/images/members/header-img.png" />
      <div class="header-title">Membership</div>
    </div>
    <members-introduct
      @handleMenuClick="handleMenuClick"
      v-if="activeName === 'Introduct'"
    ></members-introduct>
    <el-tabs v-if="activeName !== 'Introduct'" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="List and Distribution of Members" name="Introduct"> </el-tab-pane>
      <el-tab-pane label="Membership Types" name="Types">
        <membership-types></membership-types>
      </el-tab-pane>
      <el-tab-pane label="Rights and Duties of Members" name="Rights">
        <membership-rights></membership-rights>
      </el-tab-pane>
      <el-tab-pane label="How to Become Member" name="Become">
        <membership-become></membership-become>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import MembersIntroduct from "./components/members-introduct.vue";
import MembershipTypes from "./components/members-types.vue";
import MembershipRights from "./components/members-rights.vue";
import MembershipBecome from "./components/members-become.vue";
export default {
  components: {
    MembersIntroduct,
    MembershipTypes,
    MembershipRights,
    MembershipBecome,
  },
  data() {
    return {
      activeName: "Introduct",
      constants: {},
    };
  },
  methods: {
    handleMenuClick(name) {
      this.activeName = name;
    },
    handleClick: () => {},
  },
};
</script>
<style scoped lang="scss">
.mobile {
  .sp-page {
    padding-top: 50px !important;
    ::v-deep .el-tabs {
      .el-tabs__header {
        padding: 0 10px !important;
      }
      .el-tabs__content {
        padding: 0 !important;
      }
      .el-tabs__nav-scroll {
        padding: 10px 0 !important;
      }
      .el-tabs__nav-next,
      .el-tabs__nav-prev {
        margin-top: 8px;
      }
    }
  }
}
.sp-page {
  width: 100%;
  .page-header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .header-title {
      position: absolute;
      left: fw(205vw, pc);
      bottom: fh(36vh, pc);
      font-size: fh(48vh, pc);
      color: #ffffff;
      line-height: fh(58vh, pc);
    }
  }
  ::v-deep .el-tabs {
    width: 100%;
    .el-tabs__content {
      padding: fh(60vh, pc) fw(200vw, pc);
    }
    .el-tabs__header {
      width: 100%;
      left: 0;
      background: #ececec;
      padding: 0 fw(200vw, pc);
      margin-bottom: 0;
    }
    .el-tabs__nav-scroll {
      padding: fh(30vh, pc) 0 !important;
    }
    .el-tabs__item {
      font-size: fh(16vh, pc);
      color: #999999;
      &.is-active {
        color: #333333;
        font-size: fh(18vh, pc);
      }
    }
    .el-tabs__active-bar {
      bottom: fh(-30vh, pc);
      background: #0077d4;
    }
  }
}
</style>
